function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export const makeVariablePattern = () => /\{\{([^}]+)\}\}/g;
export const VARIABLE_PRESENCE_PATTERN = /\{\{[^}]+\}\}/;
const MAX_VARIABLE_LABEL_LENGTH = 200;
const MAX_VARIABLE_DEFAULT_VALUE_LENGTH = 1000;
const HTML_TAG_PATTERN = /<\/?[a-zA-Z]/;
export function validateTemplateVariableLabel(label) {
  const trimmed = label.trim();
  if (trimmed.length === 0) return null;
  if (trimmed.length > MAX_VARIABLE_LABEL_LENGTH) return 'Label exceeds maximum length';
  if (HTML_TAG_PATTERN.test(trimmed)) return 'Label contains invalid characters';
  return null;
}
export function validateTemplateVariableDefaultValue(value) {
  if (value.length > MAX_VARIABLE_DEFAULT_VALUE_LENGTH) return 'Default value exceeds maximum length';
  if (HTML_TAG_PATTERN.test(value)) return 'Default value contains invalid characters';
  return null;
}
export const SYSTEM_VARIABLE_CATALOG = [{
  category: 'Client',
  label: 'Client Company Name'
}, {
  category: 'Client',
  label: 'Client First Name'
}, {
  category: 'Client',
  label: 'Client Last Name'
}, {
  category: 'Client',
  label: 'Client Full Name'
}, {
  category: 'Client',
  label: 'Client Email'
}, {
  category: 'My Business',
  label: 'My Company Name'
}, {
  category: 'Agreement',
  label: 'Agreement Name'
}, {
  category: 'Agreement',
  label: 'Effective Date'
}, {
  category: 'Agreement',
  label: "Today's Date"
}, {
  category: 'Agreement',
  label: 'Current Month'
}, {
  category: 'Agreement',
  label: 'Current Year'
}];
const normalizedSystemLabels = new Set(SYSTEM_VARIABLE_CATALOG.map(entry => entry.label.toLowerCase()));
export function normalizeVariableLabel(label) {
  return label.toLowerCase();
}
export function isSystemVariable(label) {
  return normalizedSystemLabels.has(normalizeVariableLabel(label));
}
export function getSystemVariableCategory(label) {
  var _SYSTEM_VARIABLE_CATA;
  const normalized = normalizeVariableLabel(label);
  return (_SYSTEM_VARIABLE_CATA = SYSTEM_VARIABLE_CATALOG.find(entry => normalizeVariableLabel(entry.label) === normalized)) === null || _SYSTEM_VARIABLE_CATA === void 0 ? void 0 : _SYSTEM_VARIABLE_CATA.category;
}
export function extractVariableLabels(text) {
  const seen = new Set();
  const labels = [];
  extractLabelsFromText(text, seen, labels);
  return labels;
}
function extractLabelsFromText(text, seen, labels) {
  for (const match of text.matchAll(makeVariablePattern())) {
    const label = match[1].trim();
    const normalized = normalizeVariableLabel(label);
    if (label.length > 0 && label.length <= MAX_VARIABLE_LABEL_LENGTH && !seen.has(normalized)) {
      seen.add(normalized);
      labels.push(label);
    }
  }
}
function parseDeltaInput(richText) {
  if (!richText) return null;
  if (typeof richText === 'string') {
    if (!richText.trim()) return null;
    try {
      return parseDeltaInput(JSON.parse(richText));
    } catch (_unused) {
      return null;
    }
  }
  if (typeof richText !== 'object' || richText === null || Array.isArray(richText)) return null;
  const obj = richText;
  if (obj.type === 'quill-delta' && obj.value) {
    const inner = obj.value;
    if (Array.isArray(inner.ops)) {
      return {
        delta: inner,
        wrapper: obj
      };
    }
  }
  if (Array.isArray(obj.ops)) {
    return {
      delta: obj,
      wrapper: null
    };
  }
  return null;
}
function toDelta(richText) {
  var _parseDeltaInput$delt, _parseDeltaInput;
  return (_parseDeltaInput$delt = (_parseDeltaInput = parseDeltaInput(richText)) === null || _parseDeltaInput === void 0 ? void 0 : _parseDeltaInput.delta) !== null && _parseDeltaInput$delt !== void 0 ? _parseDeltaInput$delt : null;
}
export function extractVariableLabelsFromDelta(richText) {
  const delta = toDelta(richText);
  if (!(delta !== null && delta !== void 0 && delta.ops)) {
    return [];
  }
  const seen = new Set();
  const labels = [];
  for (const op of delta.ops) {
    if (typeof op.insert === 'string') {
      extractLabelsFromText(op.insert, seen, labels);
    } else if (op.insert && typeof op.insert === 'object') {
      const templateVar = op.insert['template-variable'];
      if (templateVar !== null && templateVar !== void 0 && templateVar.label) {
        const normalized = normalizeVariableLabel(templateVar.label);
        if (!seen.has(normalized)) {
          seen.add(normalized);
          labels.push(templateVar.label);
        }
      }
    }
  }
  return labels;
}
function formatDate(date) {
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
}
function formatMonthName(date) {
  return date.toLocaleDateString('en-US', {
    month: 'long'
  });
}
export function resolveSystemVariable(label, context) {
  const normalized = normalizeVariableLabel(label);
  switch (normalized) {
    case 'client company name':
      return context.clientCompanyName;
    case 'client first name':
      return context.clientFirstName;
    case 'client last name':
      return context.clientLastName;
    case 'client full name':
      if (context.clientFirstName && context.clientLastName) {
        return "".concat(context.clientFirstName, " ").concat(context.clientLastName);
      }
      return context.clientFirstName || context.clientLastName || undefined;
    case 'client email':
      return context.clientEmail;
    case 'my company name':
      return context.vendorBusinessName;
    case 'agreement name':
      return context.agreementName;
    case 'effective date':
      return context.effectiveDate ? formatDate(context.effectiveDate) : undefined;
    case "today's date":
      return formatDate(context.currentDate);
    case 'current month':
      return formatMonthName(context.currentDate);
    case 'current year':
      return String(context.currentDate.getFullYear());
    default:
      return undefined;
  }
}
export function resolveVariablesInText(text, resolvedValues) {
  return text.replace(makeVariablePattern(), (fullMatch, label) => {
    var _resolvedValues$norma;
    const trimmed = label.trim();
    return (_resolvedValues$norma = resolvedValues[normalizeVariableLabel(trimmed)]) !== null && _resolvedValues$norma !== void 0 ? _resolvedValues$norma : fullMatch;
  });
}
function resolveDeltaOps(delta, resolvedValues) {
  var _delta$ops;
  const resolvedOps = ((_delta$ops = delta.ops) !== null && _delta$ops !== void 0 ? _delta$ops : []).map(op => {
    if (typeof op.insert === 'string') {
      if (!VARIABLE_PRESENCE_PATTERN.test(op.insert)) return op;
      return _objectSpread(_objectSpread({}, op), {}, {
        insert: resolveVariablesInText(op.insert, resolvedValues)
      });
    }
    if (op.insert && typeof op.insert === 'object') {
      const templateVar = op.insert['template-variable'];
      if (templateVar !== null && templateVar !== void 0 && templateVar.label) {
        const resolved = resolvedValues[normalizeVariableLabel(templateVar.label)];
        if (resolved !== undefined) {
          return _objectSpread(_objectSpread({}, op), {}, {
            insert: resolved
          });
        }
        return op;
      }
    }
    return op;
  });
  return _objectSpread(_objectSpread({}, delta), {}, {
    ops: resolvedOps
  });
}
export function resolveVariablesInDelta(richText, resolvedValues) {
  var _parseResult$delta;
  const parseResult = parseDeltaInput(richText);
  if (!(parseResult !== null && parseResult !== void 0 && (_parseResult$delta = parseResult.delta) !== null && _parseResult$delta !== void 0 && _parseResult$delta.ops)) {
    return richText;
  }
  const resolvedDelta = resolveDeltaOps(parseResult.delta, resolvedValues);
  if (typeof richText === 'string') {
    if (parseResult.wrapper) {
      return JSON.stringify(_objectSpread(_objectSpread({}, parseResult.wrapper), {}, {
        value: resolvedDelta
      }));
    }
    return JSON.stringify(resolvedDelta);
  }
  if (parseResult.wrapper) {
    return _objectSpread(_objectSpread({}, parseResult.wrapper), {}, {
      value: resolvedDelta
    });
  }
  return resolvedDelta;
}
export function filterVariablesBySearch(variables, search) {
  const trimmed = search.trim();
  if (!trimmed) {
    return variables;
  }
  const normalizedSearch = normalizeVariableLabel(trimmed);
  return variables.filter(variable => normalizeVariableLabel(variable.label).includes(normalizedSearch));
}